import Swiper, { Navigation } from "swiper";
import "swiper/css";

Swiper.use([Navigation]);

export default class TestimonialsCarousel {
  constructor() {
    const $elements = document.querySelectorAll(".js-testimonials-carousel");

    $elements.forEach(($el) => {
      const $nextButton = $el.querySelector(".swiper-button-next");
      const $prevButton = $el.querySelector(".swiper-button-prev");
      const carousel = new Swiper($el, {
        loop: true,
        centeredSlides: true,
        slidesPerView: 1,
        navigation: {
          nextEl: $nextButton,
          prevEl: $prevButton,
        },
      });
    });
  }
}
